import { BenefitsAndAllowancesType } from "pages/employer-of-record/payments/constants";
import { COMPONENTLIST } from "../../../SetupFormGenerator/constants";
import { FieldConfig } from "../../../SetupFormGenerator/types";
import { TaxableBenefitsPaymentSettings } from "../../types";
import {
  DEFAULT_FORM_OF_INCOME_FIELD,
  DEFAULT_INTERNAL_NOTES_FIELD,
  DEFAULT_MARK_RECURRING_PAYMENT_FIELD,
  DEFAULT_RECURRING_CADENCE_FIELD,
} from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  MEDICAL_INSURANCE = "Medical insurance",
  LOANS = "Loans",
  LIVING_ACCOMMODATION = "Living accommodation",
  GROCERY = "Grocery",
}

export enum ReoccurringTaxableBenefits {
  REMOTE_WORK_STIPEND = "remote work stipend",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);
export const TaxableBenefitsTypeMessage = null;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] = [
  DEFAULT_FORM_OF_INCOME_FIELD,
  {
    label: "Pay date",
    name: "payPeriodId",
    type: COMPONENTLIST.SELECT,
    options: [{ value: "", label: "" }],
    required: true,
    disabled: false,
    disabledCheck: (data) => {
      const settings = data?.setUp.payload
        .paymentSettings as TaxableBenefitsPaymentSettings;
      const { formOfIncome, benefitType } = settings;
      const isMXRemoteWorkStipend =
        data?.setUp.workCountry === "MX" &&
        benefitType.toLowerCase() ===
          ReoccurringTaxableBenefits.REMOTE_WORK_STIPEND;
      if (
        data?.setUp.type === BenefitsAndAllowancesType.BENEFITSANDALLOWANCES &&
        (formOfIncome === "non-cash" || isMXRemoteWorkStipend)
      ) {
        return true;
      }
      return false;
    },
    renderCheck: (data) => {
      const settings = data?.setUp.payload
        .paymentSettings as TaxableBenefitsPaymentSettings;

      const { formOfIncome } = settings;
      return formOfIncome ? true : false;
    },
    conditionalMessage: (data) => {
      const settings = data?.setUp.payload
        .paymentSettings as TaxableBenefitsPaymentSettings;
      const { formOfIncome } = settings;
      const message = {
        text: "Non-cash benefits will be applied to the next pay period.",
      };

      return formOfIncome === "non-cash" ? message : null;
    },
  },
  DEFAULT_MARK_RECURRING_PAYMENT_FIELD,
  DEFAULT_RECURRING_CADENCE_FIELD,
  DEFAULT_INTERNAL_NOTES_FIELD,
];
